import expirationDateCompare from 'utils/expirationDateCompare';
import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  props: {
    gift: {
      type: Object,
      required: false,
    },
    userLoggedIn: {
      type: Boolean,
      required: true,
    },
  },
})
export default class HasGiftButtonComponent extends Vue {
  goTo() {
    if (this.hasGift) {
      this.$router.push({
        name: 'catalog-resolver',
        params: {
          hash: this.gift.signed_code_id,
        },
      });
    } else {
      this.$router.push({ name: 'activate' });
    }
  }
  get hasGift() {
    return this.gift?.status === 'activated' && expirationDateCompare(this.gift.expiration_date);
  }
}
